const REDIRECT_URL = "https://vsc9.top/";
const COUNTDOWN_SECONDS = 5;
const CIRCLE_LENGTH = 2 * Math.PI * 78;

const redirect = () => {
  window.location.href = REDIRECT_URL;
};

const initCountdown = () => {
  const valueEl = document.querySelector('[data-js="countdown-value"]');
  const progressEl = document.querySelector('[data-js="countdown-progress"]');
  const redirectBtn = document.querySelector('[data-js="redirect-btn"]');

  if (!valueEl || !progressEl) return;

  progressEl.style.strokeDasharray = String(CIRCLE_LENGTH);
  progressEl.style.transition = "none";

  let remaining = COUNTDOWN_SECONDS;
  let intervalId = null;

  const updateUI = () => {
    valueEl.textContent = String(remaining).padStart(2, "0");
    const progress = remaining / COUNTDOWN_SECONDS;
    progressEl.style.strokeDashoffset = String(CIRCLE_LENGTH * (1 - progress));
  };

  const stopCountdown = () => {
    if (intervalId !== null) {
      window.clearInterval(intervalId);
      intervalId = null;
    }
  };

  updateUI();

  requestAnimationFrame(() => {
    progressEl.style.transition = "stroke-dashoffset 1s linear";
  });

  intervalId = window.setInterval(() => {
    remaining -= 1;

    if (remaining <= 0) {
      stopCountdown();
      redirect();
      return;
    }

    updateUI();
  }, 1000);

  redirectBtn?.addEventListener("click", () => {
    stopCountdown();
    redirect();
  });
};

document.addEventListener("DOMContentLoaded", initCountdown);
